import React from "react";

// export const DialogDelete = ({ header, visible, width, footer, onHide, textContent }) => {
export const showMessages = (toast, severity = "error", summary = "", detail = "") => {
    toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
}
